function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $prefix, $setup, $props } from "@opentiny/vue-common";
import PcTemplate from "./pc.js";
import MobileTemplate from "./mobile.js";
import MobileFirstTemplate from "./mobile-first.js";
var template = function template2(mode) {
  if ("pc" === (process.env.TINY_MODE || mode)) {
    return PcTemplate;
  }
  if ("mobile" === (process.env.TINY_MODE || mode)) {
    return MobileTemplate;
  }
  if ("mobile-first" === (process.env.TINY_MODE || mode)) {
    return MobileFirstTemplate;
  }
  return PcTemplate;
};
var buttonProps = _extends({}, $props, {
  type: {
    type: String,
    default: "default"
  },
  tabindex: {
    type: String,
    default: "1"
  },
  icon: {
    type: [Object, String],
    default: ""
  },
  text: {
    type: String,
    default: ""
  },
  resetTime: {
    type: Number,
    default: 1e3
  },
  nativeType: {
    type: String,
    default: "button"
  },
  size: {
    type: String,
    default: "",
    validator: function validator(val) {
      return ["large", "medium", "small", "mini", ""].includes(val);
    }
  },
  round: Boolean,
  plain: Boolean,
  circle: Boolean,
  loading: Boolean,
  disabled: Boolean,
  autofocus: Boolean,
  buttonClass: {
    type: String,
    default: ""
  }
});
var Button = defineComponent({
  name: $prefix + "Button",
  inject: {
    buttonGroup: {
      default: ""
    }
  },
  props: buttonProps,
  setup: function setup(props, context) {
    return $setup({
      props,
      context,
      template
    });
  }
});
var version = "2.10.0";
Button.install = function(Vue) {
  Vue.component(Button.name, Button);
};
Button.version = version;
export {
  Button as default
};
